import {FullSideModalLayout} from 'components/Modal/SideModalLayout'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import {NullAsDefault} from 'views/Shared'
import WoGContext from "./WoGContext";
import {BookLinkedByWoGBlock, CloudTagsBlock, LinkedByHashTagBlock, MeditationBlock} from "./containers/WoGSider";
import {renderIf} from "../../Shared";
import {LayoutContext} from "../../../components/layouts/Default/LayoutContext";
import WoGShortcuts from "./components/WoGShortcuts";


export const WoGActions = Object.freeze({
  SHOW_BOOK_INFO_MODAL: 'show-book-info-modal',
  SHOW_RELATED_HASH_TAGS_MODAL: 'show-related-hash-tags-modal',
  SHOW_HASH_TAGS_MODAL: 'show-hash-tags-modal',
  SHOW_MEDITATION_MODAL: 'show-mediation-modal',
})

const ModalLayout = ({title, children, ...props}) => {
  const t = useTranslate()
  return (
    <FullSideModalLayout
      center={true}
      title={
        _.isString(title) ? (
          <span className="max-lines-2 font-medium text-sm text-color-000">
            {t(title)}
          </span>
        ) : (
          title
        )
      }
      {...props}>
      {children}
    </FullSideModalLayout>
  )
}

const createWoGModal = (
  Component = NullAsDefault,
  {modal, withContext = (props) => ({}), ...props} = {}
) => (
  <WoGContext.Consumer>
    {(context) => {
      const {item, modalDismissRef, setCurrent = NullAsDefault} = context ?? {}
      const onCancel = () => {
        setCurrent(null)
        if (_.isFunction(modalDismissRef?.current)) {
          modalDismissRef.current()
        }
      }
      const Wrapper = React.Fragment

      return (
        <ModalLayout
          footer={null}
          title={context.current}
          {...(modal ?? {})}
          onCancel={onCancel}>
          <Wrapper>
            <LayoutContext.Consumer>
              {({isSm}) => renderIf(isSm, <WoGShortcuts/>)}
            </LayoutContext.Consumer>
            <div className="mt-3"/>
            <Component
              onCancel={onCancel}
              {...(props ?? {})}
              {...(withContext({onCancel, ...(context ?? {})}) ?? {})}
            />
          </Wrapper>
        </ModalLayout>
      )
    }}
  </WoGContext.Consumer>
)

export const routes = {
  bookInfo: {
    path: 'book-info',
    name: 'book-info',
    action: WoGActions.SHOW_BOOK_INFO_MODAL,
    component: () => createWoGModal(BookLinkedByWoGBlock),
    exact: true,
  },
  inRelatedHashTags: {
    path: 'in-related-hash-tags',
    name: 'in-related-hash-tags',
    action: WoGActions.SHOW_RELATED_HASH_TAGS_MODAL,
    component: () => createWoGModal(LinkedByHashTagBlock),
    exact: true,
  },
  hashTags: {
    path: 'hash-tags',
    name: 'hash-tags',
    action: WoGActions.SHOW_HASH_TAGS_MODAL,
    component: () => createWoGModal(CloudTagsBlock),
    exact: true,
  },
  meditations: {
    path: 'meditations',
    name: 'meditations',
    action: WoGActions.SHOW_MEDITATION_MODAL,
    component: () => createWoGModal(MeditationBlock),
    exact: true,
  },
}

export const getActionRoute = (action) => _.find(routes, {action})

export const settingRoutes = {}
